import React, { useRef } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton} from '@ionic/react';

export function EnterPasswordModal(props) {

    //let [password, setPassword] = useState(null);
    let passwordRef = useRef('');

    /*function passwordHandler(e){
        setPassword(e);
    }*/

    function submitHandler() {

        props.onSubmitPassword(passwordRef.current.value.replace(/\s+/g, ''));
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonSlides>
                <IonSlide>
                    <IonItem> 
                        <label for='adminPasswordCreateRoom'>Enter Password: </label>
                        <IonInput type='password' id='adminPasswordCreateRoom' ref={passwordRef}></IonInput>
                    </IonItem>
                    <IonButton onClick={submitHandler}> Submit </IonButton>                         
                </IonSlide>
            </IonSlides>
            <IonButton onClick={closeModalHandler}>Cancel </IonButton>
        </IonModal>) : null}
    </React.Fragment>
    )
}
